import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Phone, Mail, MapPin, ChevronRight, MessageCircle } from 'lucide-react';
import { navigation, contactInfo, socialLinks, brandInfo } from '../data/mockData';

const Footer = ({ onOpenBuilder }) => {
  const handleNavClick = (e, href) => {
    e.preventDefault();
    if (href === '#builder') {
      onOpenBuilder();
    } else {
      const element = document.querySelector(href);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <footer className="bg-[#1a1a1a] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-6">
              <div className="bg-white/90 rounded-lg p-1 mr-3">
                <img 
                  src="https://customer-assets.emergentagent.com/job_a00d389d-55ed-4ba2-b25d-abeefa2cf3c1/artifacts/kc0888c6_Art%20%26%20Illustration%20-%20Edited.png" 
                  alt="Zamzam Umrah Logo" 
                  className="h-14 w-auto"
                />
              </div>
              <div>
                <span className="block text-[#d4af37] text-xl font-bold tracking-wider" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>ZAMZAM</span>
                <span className="block text-white text-sm tracking-[0.15em]">UMRAH BUILDER</span>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              {brandInfo.description}
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#d4af37] transition-colors"
                >
                  {social.icon === 'facebook' && <Facebook className="w-4 h-4" />}
                  {social.icon === 'twitter' && <Twitter className="w-4 h-4" />}
                  {social.icon === 'instagram' && <Instagram className="w-4 h-4" />}
                  {social.icon === 'linkedin' && <Linkedin className="w-4 h-4" />}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xl font-bold mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {navigation.map((item) => (
                <li key={item.name}>
                  <a
                    href={item.href}
                    onClick={(e) => handleNavClick(e, item.href)}
                    className="text-gray-400 hover:text-[#d4af37] transition-colors flex items-center gap-2"
                  >
                    <ChevronRight className="w-4 h-4" />
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Umrah Services */}
          <div>
            <h4 className="text-xl font-bold mb-6">Umrah Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="#packages" className="text-gray-400 hover:text-[#d4af37] transition-colors flex items-center gap-2">
                  <ChevronRight className="w-4 h-4" />
                  Umrah Packages
                </a>
              </li>
              <li>
                <a href="#builder" onClick={(e) => handleNavClick(e, '#builder')} className="text-gray-400 hover:text-[#d4af37] transition-colors flex items-center gap-2">
                  <ChevronRight className="w-4 h-4" />
                  Build Your Umrah
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-[#d4af37] transition-colors flex items-center gap-2">
                  <ChevronRight className="w-4 h-4" />
                  Makkah Hotels
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-[#d4af37] transition-colors flex items-center gap-2">
                  <ChevronRight className="w-4 h-4" />
                  Madinah Hotels
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-[#d4af37] transition-colors flex items-center gap-2">
                  <ChevronRight className="w-4 h-4" />
                  Ground Transport
                </a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-[#d4af37] transition-colors flex items-center gap-2">
                  <ChevronRight className="w-4 h-4" />
                  Visa Services
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xl font-bold mb-6">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#d4af37] flex-shrink-0 mt-1" />
                <span className="text-gray-400">{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#d4af37]" />
                <span className="text-gray-400">{contactInfo.phone}</span>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="w-5 h-5 text-green-500" />
                <span className="text-gray-400">WhatsApp: {contactInfo.whatsapp}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-[#d4af37]" />
                <span className="text-gray-400">{contactInfo.email}</span>
              </li>
            </ul>

            {/* Build Umrah Button */}
            <button
              onClick={onOpenBuilder}
              className="mt-6 px-6 py-3 bg-[#d4af37] text-black font-bold rounded-md hover:bg-[#c4a030] transition-colors w-full"
            >
              BUILD YOUR UMRAH
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} ZamZam Umrah. All Rights Reserved.
            </p>
            <div className="text-gray-500 text-sm">
              Cheapest Umrah Online
            </div>
            <div className="flex gap-6">
              <a href="/privacy" className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors">
                Privacy Policy
              </a>
              <a href="/terms" className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors">
                Terms & Conditions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
